import modules from '@/app/config/modules'
import assign from 'lodash/assign'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {},

  mutations: {
    init(state) {
      const persisted = localStorage.getItem(process.env.VUE_APP_ID)
      if (persisted) {
        assign(state, JSON.parse(persisted))
      }
    },

    // purge (state) {
    //   localStorage.removeItem(process.env.VUE_APP_ID)
    // }
  },

  actions: {},

  modules,
})

store.subscribe((_, state) => {
  localStorage.setItem(process.env.VUE_APP_ID, JSON.stringify(state))
})

export default store
